import React, { lazy, Suspense } from 'react';
import HeroSection from '../components/home/HeroSection';
import ServicesSection from '../components/home/ServicesSection';

const WhyChooseUs = lazy(() => import('../components/home/WhyChooseUs'));
const AboutPreview = lazy(() => import('../components/home/AboutPreview'));
const GallerySection = lazy(() => import('../components/home/GallerySection'));
const TestimonialsSection = lazy(() => import('../components/home/TestimonialsSection'));
const FAQSection = lazy(() => import('../components/home/FAQSection'));

export default function HomePage({ onBookClick }) {
  return (
    <>
      <HeroSection onBookClick={onBookClick} />
      <ServicesSection onBookClick={onBookClick} preview={true} />
      <Suspense fallback={null}>
        <WhyChooseUs />
        <AboutPreview />
        <GallerySection />
        <TestimonialsSection />
        <FAQSection />
      </Suspense>
    </>
  );
}
